import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN =
    process.env.REACT_APP_MIX_PANNEL_API_KEY ||
    process.env.NEXT_PUBLIC_MIX_PANNEL_API_KEY;

let mixpanelReady = false;
if (typeof MIXPANEL_TOKEN === 'string' && MIXPANEL_TOKEN.length > 0) {
    try {
        mixpanel.init(MIXPANEL_TOKEN, {
            track_pageview: true,
            persistence: 'localStorage',
        });
        mixpanelReady = true;
    } catch (e) {
        console.warn('Mixpanel init failed:', e);
    }
}

const getUniqueSessionId =()=>{
    if(window){

        let interaction = window?.sessionStorage?.getItem("interaction")
        let parseInteraction = JSON.parse(interaction)
        return parseInteraction?.first_session_id || "anonymos" 
    }
}
// mixpanel.identify(getUniqueSessionId())



export const createMixPanelCustomEvent = (customEvent) => {
    if (!mixpanelReady || !customEvent || !customEvent.event_name) {
        return;
    }
    const windowAvailaible = typeof window !== 'undefined';
    let dataLayerObj = {};
    if (windowAvailaible) {
        if (customEvent.event_name) {
            dataLayerObj.mix_panel_event_name = customEvent.event_name;
        }
        if (customEvent.btn_label) {
            dataLayerObj.mix_panel_btn_label = customEvent.btn_label;
        }
        if (customEvent.feature_name) {
            dataLayerObj.mix_panel_feature_name = customEvent.feature_name;
        }
        if (customEvent.segment_name) {
            dataLayerObj.mix_panel_segment_name = customEvent.segment_name;
        }
        if (customEvent.action_name) {
            dataLayerObj.mix_panel_action_name = customEvent.action_name;
        }
        if (customEvent.btn_value) {
            dataLayerObj.mix_panel_btn_value = customEvent.btn_value;
        }
    }
    try {
        mixpanel.track(customEvent.event_name, dataLayerObj);
    } catch (e) {
        console.warn('Mixpanel track failed:', e);
    }
};
